import styled from 'styled-components';

import { Button as BaseButton } from 'components/uikit/Button/Button';
import { Spinner as BaseSpinner } from 'components/uikit/Spinner/Spinner';

export const Button = styled(BaseButton).attrs({ size: 's', theme: '2' })`
  margin-right: 6px;
`;

export const Spinner = styled(BaseSpinner).attrs({ size: 's', theme: '1' })`
  --size: 16px;

  margin-right: 14px;
`;

export * from '../../Insurance.styles';
